// extracted by mini-css-extract-plugin
module.exports = {"TimeGridHeader":"TimeGridHeader__cyPQe","TimeGridHeader__mutedText":"TimeGridHeader__mutedText__3LTh7"};